import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, crudUpdateMany, translate } from 'react-admin';

class MoveToCanceledButton extends Component {
    handleClick = () => {
        const { basePath, crudUpdateMany, resource, selectedIds } = this.props;
        crudUpdateMany(resource, selectedIds, { status: 'canceled' }, basePath);
    };

    render() {
        return (
            <Button label={this.props.translate(`resources.payments.moveto.canceled`)} onClick={this.handleClick} />
        );
    }
}

export default translate(connect(undefined, { crudUpdateMany })(MoveToCanceledButton));